import { render, staticRenderFns } from "./RefertoUploader.vue?vue&type=template&id=9eb1ab88&"
import script from "./RefertoUploader.vue?vue&type=script&lang=js&"
export * from "./RefertoUploader.vue?vue&type=script&lang=js&"
import style0 from "./RefertoUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports